import { isValidSelectorString } from '@/utils/validations/selector.validation';
import { z } from 'zod';
import { MarginRateSchema } from '../common/margin-rate.schema';
import { DistributorKind } from './DistributorKind';

export const AgencySchema = z.object({
  name: z.string({ message: 'Le nom est requis' }),
  logo: z
    .union([
      z.instanceof(Blob, { message: 'Fichier incorrect ou inexistant' }),
      z.null(),
      z.string(),
    ])
    .optional(),
  address: z.string({ message: "L'adresse est requise" }),
  city: z.string({ message: 'La ville est requise' }),
  postalCode: z.coerce.number({ message: 'Le code postal est requis' }),
  country: isValidSelectorString('Le pays est requis'),
  siren: z
    .string({ message: 'Le numéro SIREN est requis' })
    .min(9, { message: 'Le numéro SIREN doit contenir au moins 9 caractères' }),
  marginRate: MarginRateSchema.optional(),
  website: z
    .union([
      z.string().url({ message: 'Le site web est invalide' }),
      z.string().max(0),
    ])
    .optional(),
});

export const DistributorRegisterBaseSchema = z.object({
  firstName: z
    .string({ message: 'Le prénom est requis' })
    .min(1, { message: 'Le prénom est requis' }),
  lastName: z.string({ message: 'Le nom est requis' }).min(1, {
    message: 'Le nom est requis',
  }),
  email: z
    .string({
      required_error: "L'email est requis",
      invalid_type_error: 'Email incorrect',
    })
    .email({ message: 'Email non valide' }),
  phoneNumber: z
    .string()
    .regex(
      /^\+?[0-9]+$/,
      'Le numéro de téléphone ne doit contenir que des chiffres ou un + au début',
    )
    .min(5, 'Le numéro de téléphone doit contenir au moins 5 caractères'),
  password: z
    .string({
      required_error: 'Le mot de passe est requis',
    })
    .min(8, 'Le mot de passe doit contenir au moins 8 caractères'),
  distributorKind: z
    .nativeEnum(DistributorKind)
    .default(DistributorKind.TravelAgency),
  network: z
    .object({
      label: z.string(),
      value: z.string().optional(),
    })
    .optional(),
  agency: AgencySchema,
});

export const DistributorRegisterSchema =
  DistributorRegisterBaseSchema.superRefine((data, ctx) => {
    if (data.distributorKind === DistributorKind.TravelAgency) {
      if (!data.network?.label) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: 'Le réseau est requis',
          path: ['network'],
        });
      }
    }
  });

export type DistributorRegisterFormData = z.infer<
  typeof DistributorRegisterSchema
>;
